import { State as DiscountsState } from '@epicuro-next/state/deprecated-merchandise-prices';
import { PriceData } from 'graphql-api/gql-api-interfaces';

import { PriceType, ProductPriceData } from '../models';

export const enrichPricesWithDiscounts = (
  pricesData: ProductPriceData,
  discounts: DiscountsState,
): ProductPriceData => {
  return Object.keys(pricesData).reduce(
    (acc: ProductPriceData, key: PriceType) => {
      const priceData: PriceData[] = pricesData[key].map((item: PriceData) => {
        const { prices, productId, brandId } = item;
        const discount = +discounts[item.productId];

        if (!!discount) {
          const enrichedPrices =
            prices.length > 0
              ? prices.map((priceRange) => ({
                  ...priceRange,
                  discount: { max: discount, min: discount },
                }))
              : [{ discount: { max: discount, min: discount } }];

          return {
            productId,
            brandId,
            prices: enrichedPrices,
          };
        }

        return item;
      });

      acc[key] = priceData;

      return acc;
    },
    {} as ProductPriceData,
  );
};
